import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SetupSleeperData, SetupSleeperForm, SiqNotification } from "@models/app/helpers.model";
import { Bed } from "@models/bed/bed.model";
import { Navigate } from "@ngxs/router-plugin";
import { Store } from "@ngxs/store";
import { SetSiqNotification } from "@store/app/app.actions";
import { BedsSelectors } from "@store/beds/beds.selectors";
import { BedSide, ShouldAddPartnerSleeper } from "./enum.helper";

export class RegistrationHelper {
  static createSetupSleeperForm(bed: Bed, side: number | null, sleeperData: SetupSleeperData | null): FormGroup<SetupSleeperForm> {
    return new FormGroup<SetupSleeperForm>({
      firstName: new FormControl(sleeperData?.firstName ? sleeperData.firstName : null, [Validators.required]),
      birthMonth: new FormControl(sleeperData?.birthMonth ? sleeperData.birthMonth : null),
      birthYear: new FormControl(sleeperData?.birthYear ? sleeperData.birthYear : null, [Validators.required]),
      height: new FormControl(sleeperData?.height ? sleeperData.height : null, [Validators.required]),
      weight: new FormControl(sleeperData?.weight ? sleeperData.weight : null, [Validators.required]),
      sleepGoal: new FormControl(sleeperData?.sleepGoal ? sleeperData.sleepGoal : null, [Validators.required]),
      gender: new FormControl(sleeperData?.gender !== null ? sleeperData?.gender ?? null : null),
      bedId: new FormControl(bed.bedId, [Validators.required]),
      side: new FormControl(bed.isKidsBed ? BedSide.Left : side ?? null, [Validators.required]),
      duration: new FormControl(bed.isKidsBed ? 30 : 0)
    });
  }

  static redirectToTheNextStep(store: Store, shouldAddSecondSleeper: number | null , showToast = false): void {
    const bedsWithoutSleepers = store.selectSnapshot(BedsSelectors.bedsForSetup);
    const shouldRedirectToSelectBed = bedsWithoutSleepers && bedsWithoutSleepers.length > 0;
    const setupSleepersFrom = localStorage.getItem('setupSleepersFrom');
    if (shouldAddSecondSleeper === ShouldAddPartnerSleeper.Yes) {
      store.dispatch(new Navigate(['pages/setup/setup-partner']));
      this.setSiqNotification(store, showToast, 'set up sleep partner');
    } else if (shouldRedirectToSelectBed && !setupSleepersFrom) {
      store.dispatch(new Navigate(['pages/setup/select-bed']));
      this.setSiqNotification(store, showToast, 'select bed');
    } else {
      if (setupSleepersFrom) {
        store.dispatch(new Navigate(['pages/setup/congratulation']));
        this.setSiqNotification(store, showToast, 'congratulation');
      } else {
        store.dispatch(new Navigate(['pages/setup/sleep-research']));
        this.setSiqNotification(store, showToast, 'sleep research');
      }
    }
  }

  static getProceedSkipActionFlow(): string {
    const addSleepersFrom = localStorage.getItem('setupSleepersFrom');
    switch (addSleepersFrom) {
      case 'pages/smart-bed/details/sleeper-setup':
        return 'bed_settings';
      case 'pages/account-settings/details/orders':
        return 'account_settings';
      case 'pages/sleep':
        return 'sleeper_switcher';
      default:
        return 'registration';
    }
  }

  private static setSiqNotification(store: Store, showToast: boolean, sourceScreen: string): void {
    if (showToast)
      store.dispatch(new SetSiqNotification(new SiqNotification('Invitation sent!', sourceScreen, 'registration')));
  } 
}